<form>
  <payee-chip-dropdown
    [displayWith]="displayWith"
    [placeholder]="'CASES_TABLE.FILTERS.DEBTOR_NAME.LABEL' | translate"
    [selected]="selected"
    [(dropdownOpen)]="dropdownOpen"
    (removed)="clearFilter()">
    <payee-form-field>
      <input
        payee-input
        (paste)="onPaste($event)"
        [formControl]="debtorNameControl"
        [placeholder]="
          'CASES_TABLE.FILTERS.DEBTOR_NAME.PLACEHOLDER' | translate
        "
        [matAutocomplete]="auto" />
      <span
        *ngIf="debtorNameControl.invalid && debtorNameControl.dirty"
        payee-error>
        {{ 'ERROR_MESSAGES.FIELD_REQUIRED' | translate }}
      </span>
      <span
        payee-suffix
        *ngIf="loading">
        <mat-progress-spinner
          mode="indeterminate"
          diameter="24"></mat-progress-spinner>
      </span>
      <mat-autocomplete #auto="matAutocomplete">
        <mat-option
          *ngFor="let option of debtorOptions"
          [value]="option.name">
          {{ option.name }}
        </mat-option>
      </mat-autocomplete>
    </payee-form-field>
    <button
      payee-button
      class="top-margin-10"
      color="primary"
      (click)="applyFilter()">
      {{ 'CASES_TABLE.FILTERS.APPLY' | translate }}
    </button>
  </payee-chip-dropdown>
</form>
